module.exports = __webpack_public_path__ + "img/unique-2-md.7178da8.webp";